import { z } from 'zod';
/**
 * Этапы воронки.
 *
 * Порядок подтверждён заказчиком 08.09.2026: «Вышло в линию» — самостоятельный
 * этап между стажировкой и штатом (вопрос Q1 в docs/99-open-questions.md).
 * В HTML-прототипах кабинетов руководителей этого этапа не было.
 */
export const FUNNEL_STAGES = [
    'obuchenie',
    'zapis',
    'stazhirovka',
    'linia',
    'shtat',
    'nedelya',
    'vrabote',
    'ushel',
];
export const funnelStageSchema = z.enum(FUNNEL_STAGES);
/** Этапы пути кандидата без терминального «ушёл» — в порядке прохождения. */
export const ACTIVE_STAGES = FUNNEL_STAGES.filter((s) => s !== 'ushel');
export const STAGE_LABELS = {
    obuchenie: 'Обучение',
    zapis: 'Запись',
    stazhirovka: 'Стажировка',
    linia: 'Линия',
    shtat: 'Штат',
    nedelya: 'Неделя',
    vrabote: 'В работе',
    ushel: 'Ушёл',
};
/**
 * Этапы, которые видит сам кандидат во вкладке «Ваш путь».
 * Внутренние этапы после выхода в штат ему не показываются.
 */
export const CANDIDATE_PATH_STAGES = ['obuchenie', 'zapis', 'stazhirovka', 'shtat'];
export function stageIndex(stage) {
    return FUNNEL_STAGES.indexOf(stage);
}
/** Двигается ли кандидат вперёд по воронке. Уход возможен с любого этапа. */
export function isForwardTransition(from, to) {
    if (to === 'ushel')
        return true;
    if (from === 'ushel')
        return false;
    return stageIndex(to) > stageIndex(from);
}
/**
 * Этапы сводной воронки в кабинете «Статистика».
 *
 * Первые два — агрегатные: они считаются по итогам Zoom-встреч, а не по
 * конкретным людям, поэтому в funnel_stage их нет.
 */
export const FUNNEL_REPORT_STAGES = [
    { key: 'zoom', label: 'Зум' },
    { key: 'chat', label: 'Перешли в чат' },
    { key: 'obuchenie', label: 'Приступили к обучению' },
    { key: 'zapis', label: 'Запись на стажировку' },
    { key: 'stazhirovka', label: 'Вышло на старт стажировки' },
    { key: 'linia', label: 'Вышло в линию' },
    { key: 'shtat', label: 'В штат' },
    { key: 'nedelya', label: 'Больше недели' },
];
export const messengerSchema = z.enum(['telegram', 'max']);
export const MESSENGER_LABELS = {
    telegram: 'Telegram',
    max: 'MAX',
};
//# sourceMappingURL=funnel.js.map